module.exports = __webpack_public_path__ + "img/empty-box-open.6e4fb19a.svg";